module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"sitesTitle":"Lokasyonlar","userGroup":"Kullanıcı Grubu","activeUsers":"Aktif Kullanıcılar","addNewUserGroup":"Yeni Kullanıcı Grubu Ekle","userGroupsPermissions":"Kullanıcı Grupları & İzinler"},"en":{"sitesTitle":"Sites","userGroup":"User Group","activeUsers":"Active Users","addNewUserGroup":"Add New User Group","userGroupsPermissions":"User Groups & Permissions"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Setting/Permissions.vue
// module id = zfIk
// module chunks = 1